import type { DSDialogPosition } from "./types";
import { DS_DIALOG_POSITIONS } from "./types";

export const DS_DIALOG_CLASSES = {
  Root: "ds-dialog",
  Modal: "ds-dialog--modal",
  Dialog: "ds-dialog--dialog",
  Absolute: "ds-dialog--absolute",
  Content: "ds-dialog__content",
  Header: "ds-dialog__header",
  HeaderContent: "ds-dialog__header-content",
  Title: "ds-dialog__title",
  TitleText: "ds-dialog__title-text",
  Body: "ds-dialog__body",
  Footer: "ds-dialog__footer",
} as const;

export const DS_DIALOG_POSITION_CLASSES: Record<DSDialogPosition, string> = {
  [DS_DIALOG_POSITIONS.Center]: "ds-dialog--position-center",
  [DS_DIALOG_POSITIONS.TopLeft]: "ds-dialog--position-top-left",
  [DS_DIALOG_POSITIONS.TopCenter]: "ds-dialog--position-top-center",
  [DS_DIALOG_POSITIONS.TopRight]: "ds-dialog--position-top-right",
  [DS_DIALOG_POSITIONS.BottomLeft]: "ds-dialog--position-bottom-left",
  [DS_DIALOG_POSITIONS.BottomCenter]: "ds-dialog--position-bottom-center",
  [DS_DIALOG_POSITIONS.BottomRight]: "ds-dialog--position-bottom-right",
};
